package top.wcpe.allincore.ui.runtime.render

import top.wcpe.allincore.layout.engine.Box
import top.wcpe.allincore.ui.runtime.element.TabView
import top.wcpe.allincore.ui.runtime.element.UIElement
import top.wcpe.allincore.ui.runtime.render.UiRenderBridge
import top.wcpe.allincore.ui.runtime.theme.ThemeAccess
import kotlin.math.max

/**
 * TabView 渲染器（接入主题）。
 * - 整体 bg：DSL > `surface`
 * - header bar：`surfaceContainer`（衬底）
 * - 非激活 tab：`surfaceContainerHigh` + 文本 `onSurfaceVariant`
 * - 激活 tab：`primaryContainer` + 文本 `onPrimaryContainer`
 * - 分隔线 / header 底部线：`outline`，宽度由 `theme.borderWidth` 控制
 *
 * content 区由 UIRenderer 在 TabView 特化分支给 active tab 子节点加 +HEADER_HEIGHT 的 Y 偏移并裁剪绘制。
 */
@Suppress("MagicNumber")
class TabViewRenderer : Renderer {

    override fun render(element: UIElement<*>, box: Box, bridge: UiRenderBridge) {
        val tv = element as TabView
        val t = ThemeAccess.current()
        val bw = t.borderWidth
        val tabs = tv.tabs()

        // 视觉覆盖解析：覆盖优先、主题兜底（null = 回退主题 token，保持零回归）
        val headerHeight = tv.effectiveHeaderHeight()
        val tabPadding = tv.tabPadding() ?: 2f
        val activeBg = tv.tabActiveBackgroundColor() ?: t.primaryContainer
        val inactiveBg = tv.tabInactiveBackgroundColor() ?: t.surfaceContainerHigh
        val activeText = tv.tabActiveTextColor() ?: t.onPrimaryContainer
        val inactiveText = tv.tabInactiveTextColor() ?: t.onSurfaceVariant
        val indicatorColor = tv.tabIndicatorColor() ?: t.outline

        // 整体背景：DSL 显式色 > 主题 surface
        val bg = tv.style().backgroundColor()
        if ((bg ushr 24) != 0) {
            bridge.fillRect(box.x(), box.y(), box.width(), box.height(), bg)
        }

        // header bar 衬底
        bridge.fillRect(box.x(), box.y(), box.width(), headerHeight, t.surfaceContainer)
        if (tabs.isEmpty()) return

        val w = box.width() / tabs.size
        for (i in tabs.indices) {
            val tx = box.x() + i * w
            val active = i == tv.activeIndex()
            val tabBg = if (active) activeBg else inactiveBg
            val textColor = if (active) activeText else inactiveText
            bridge.fillRect(tx, box.y(), w, headerHeight, tabBg)
            // 分隔线
            if (i > 0) {
                bridge.fillRect(tx, box.y(), bw, headerHeight, indicatorColor)
            }
            val title = tabs[i].title()
            if (title.isNotEmpty()) {
                val tw = bridge.textWidth(title, 1f)
                val cx = tx + max(tabPadding, (w - tw) / 2f)
                bridge.drawText(title, cx, box.y() + 2f, textColor, 1f)
            }
        }
        // header 底部边
        bridge.fillRect(box.x(), box.y() + headerHeight - bw, box.width(), bw, indicatorColor)
    }
}
